module.exports = __webpack_public_path__ + "assets/images/GreenShade.273876f808ff664316a6ac60ad476865.png";